import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import RewardAdsFilterPill from './RewardAdsFilterPill'

export default withTranslation()(function RewardAdsFilterBar({
  t, search, onChangeSearch, status, onChangeStatus, targeting, onChangeTargeting
}) {
  const statusOptions = [
    { label: t('rewardAds.filters.all_statuses'), value: '' },
    { label: t('rewardAds.filters.status_active'), value: 'active' },
    { label: t('rewardAds.filters.status_scheduled'), value: 'scheduled' },
    { label: t('rewardAds.filters.status_completed'), value: 'completed' }
  ]

  const targetingOptions = [
    { label: t('rewardAds.filters.all_customers'), value: '' },
    { label: 'Target Filter Name 1', value: 'target-1' },
    { label: 'Target Filter Name 2', value: 'target-2' },
    { label: 'Target Filter Name 3', value: 'target-3' },
    { label: 'Target Filter Name 5', value: 'target-5' }
  ]

  return (
    <div className="flex flex-wrap items-center gap-3 mb-5">
      <div className="relative w-full sm:w-[280px] shrink-0">
        <input
          type="text"
          value={search}
          onChange={(event) => onChangeSearch(event.target.value)}
          placeholder={t('rewardAds.filters.search_placeholder')}
          className="w-full bg-white border border-border-lines rounded-full pl-9 pr-3 py-2 text-sm outline-none"
        />
        <UIcons.UilSearch className="text-placeholder absolute top-1/2 -translate-y-1/2 left-3" size={16} />
      </div>

      <RewardAdsFilterPill
        label={t('rewardAds.filters.all_statuses')}
        active={status ? { label: statusOptions.find((option) => option.value === status)?.label, value: status } : null}
        options={statusOptions}
        onSelect={(option) => onChangeStatus(option.value)}
        onClear={() => onChangeStatus('')}
      />

      <RewardAdsFilterPill
        label={t('rewardAds.filters.all_targeting')}
        active={targeting ? { label: targetingOptions.find((option) => option.value === targeting)?.label, value: targeting } : null}
        options={targetingOptions}
        onSelect={(option) => onChangeTargeting(option.value)}
        onClear={() => onChangeTargeting('')}
      />

      <RewardAdsFilterPill
        label={t('rewardAds.filters.all_time')}
        active={null}
        options={[{ label: t('rewardAds.filters.all_time'), value: '' }]}
        onSelect={() => {}}
        onClear={() => {}}
      />
    </div>
  )
})
